module.exports = __webpack_public_path__ + "img/a3.5edea4d3.jpg";